import styled from 'styled-components';
import Spinner from 'react-bootstrap/Spinner';

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;

  ::before {
    content: '';
    position: fixed;
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 100%;
  }
`;

export const CustomSpinner = styled(Spinner)`
  position: absolute;
  top: 50%;
  left: 50%;
  height: 50px;
  width: 50px;
  border-width: 3px;
  margin: -25px 0 0 -25px;
`;
